






















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class HeaderBar extends Vue {
  @Prop({ type: String, default: '' })
  title!: string
  fixClass = ''

  mounted() {}
}
